
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleAboutClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (location.pathname === '/') {
      // Already on homepage, just scroll to section
      const aboutSection = document.getElementById('about');
      if (aboutSection) {
        aboutSection.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // Navigate to homepage then scroll to about section
      navigate('/');
      setTimeout(() => {
        const aboutSection = document.getElementById('about');
        if (aboutSection) {
          aboutSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <img
              src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/3b1dba158396e9464e339f7473f9705b.png"
              alt="بوابة القبول الجامعي"
              className="w-12 h-12 object-contain"
            />
            <div className="flex flex-col">
              <span className={`text-xl font-bold font-cairo ${isScrolled ? 'text-primary-700' : 'text-white'}`}>
                بوابة القبول
              </span>
              <span className={`text-xs font-tajawal ${isScrolled ? 'text-gray-600' : 'text-white/80'}`}>
                دليلك للجامعات السعودية
              </span>
            </div>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`font-tajawal font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-primary-600' : 'text-white hover:text-saudi-gold-400'
              }`}
            >
              الرئيسية
            </Link>
            <Link
              to="/opportunities"
              className={`font-tajawal font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-primary-600' : 'text-white hover:text-saudi-gold-400'
              }`}
            >
              الجامعات
            </Link>
            <a
              href="#about"
              onClick={handleAboutClick}
              className={`font-tajawal font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-primary-600' : 'text-white hover:text-saudi-gold-400'
              }`}
            >
              عن المنصة
            </a>
            <button
              onClick={() => navigate('/opportunities')}
              className="bg-primary-700 text-white px-6 py-2.5 rounded-full font-tajawal font-medium hover:bg-primary-800 transition-colors flex items-center gap-2 cursor-pointer whitespace-nowrap"
            >
              <span>ابدأ البحث</span>
              <i className="ri-search-line"></i>
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-white/10">
            <div className="flex flex-col gap-4 mt-4">
              <Link
                to="/"
                className={`font-tajawal font-medium transition-colors cursor-pointer ${
                  isScrolled ? 'text-gray-700 hover:text-primary-600' : 'text-white hover:text-saudi-gold-400'
                }`}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                الرئيسية
              </Link>
              <Link
                to="/opportunities"
                className={`font-tajawal font-medium transition-colors cursor-pointer ${
                  isScrolled ? 'text-gray-700 hover:text-primary-600' : 'text-white hover:text-saudi-gold-400'
                }`}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                الجامعات
              </Link>
              <a
                href="#about"
                onClick={(e) => {
                  handleAboutClick(e);
                  setIsMobileMenuOpen(false);
                }}
                className={`font-tajawal font-medium transition-colors cursor-pointer ${
                  isScrolled ? 'text-gray-700 hover:text-primary-600' : 'text-white hover:text-saudi-gold-400'
                }`}
              >
                عن المنصة
              </a>
              <button
                onClick={() => {
                  navigate('/opportunities');
                  setIsMobileMenuOpen(false);
                }}
                className="bg-primary-700 text-white px-6 py-2.5 rounded-full font-tajawal font-medium hover:bg-primary-800 transition-colors flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap"
              >
                <span>ابدأ البحث</span>
                <i className="ri-search-line"></i>
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
